module.exports = __webpack_public_path__ + "b90df89a432794f3b1c99246eec90e3c.png";